/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListPermissionsRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {ListPermissionsResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const listPermissions = (request: ListPermissionsRequest, options?: CashRequestOptions) => post<ListPermissionsRequest, ListPermissionsResponse>("/2.0/cash/list-permissions", request, {...options, rejectOnError: true })